import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerThree from "../components/DashBoardLayerThree";

const HomePageOne = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Digifinex/Spread" />
        <DashBoardLayerThree />
      </MasterLayout>
    </>
  );
};

export default HomePageOne;
